<script setup>
import axios from "axios";
import { useRouter, useRoute } from 'vue-router';
import LocationExt from "../utils/location-ext.js";
import {ref, computed, onMounted} from "vue";
import { useStore } from 'vuex';

const router = useRouter();
const store = useStore();
const setQq = (value) => store.commit('setQq', value);
const isShowSuccess = ref(false);
const isShowLoading = ref(false);
const inputLen = computed(() => content.value.trim().length);
const content = ref('');
const qq = ref('');
const imageList = ref([]);
const fileList = ref([]);
const fileInput = ref(null);
const imageListWrapper = ref(null);
const le = new LocationExt();
const route = useRoute();
if (route.params.productId) {
  const productId = parseInt(route.params.productId);
  const setProductId = (value) => store.commit('setProductId', value);
  const setBuildModel = (value) => store.commit('setBuildModel', value);
  const setSystemVersion = (value) => store.commit('setSystemVersion', value);
  const setSoftVersion = (value) => store.commit('setSoftVersion', value);
  const setSoftBuild = (value) => store.commit('setSoftBuild', value);
  const setImei = (value) => store.commit('setImei', value);
  const setGuid = (value) => store.commit('setGuid', value);
  const setBuildID = (value) => store.commit('setBuildID', value);
  const setChannel = (value) => store.commit('setChannel', value);
  const setRoot = (value) => store.commit('setRoot', value);
  const setScore = (value) => store.commit('setScore', value);
  const setUninstall = (value) => store.commit('setUninstall', value);
  setProductId(productId);
  setBuildModel(le.get('BuildModel'));
  setSystemVersion(le.get('Release'));
  setSoftVersion(le.get('VersionName'));
  setSoftBuild(le.get('Buildno'));
  setImei(le.get('imei'));
  setGuid(le.get('guid'));
  setBuildID(le.get('BuildID'));
  setChannel(le.get('channel'));
  setRoot(le.get('Root'));
  setScore(le.get('score'));
  setUninstall(le.get('uninstall'));
}

onMounted(() => {
  qq.value = computed(() => store.getters.getQq).value;
});
function goToHome() {
  router.push({
    path: '/index',
  });
}
function goToMyList() {
  router.push({
    path: '/myList',
  });
}
const submitButtonClass = computed(() => {
  return content.value.trim().length >= 8 ? 'feedback' : 'feedback-not-ok';
});
const productId = computed(() => parseInt(store.getters.getProductId));
// 手机管家系列（productId 1/2/68）不显示"联系我们"，其他产品显示
const showContact = computed(() => ![1, 2, 68].includes(productId.value));

const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    window.showToast({ message: '已复制到粘贴板' });
  } catch (err) {
    fallbackCopyToClipboard(text);
  }
}

function fallbackCopyToClipboard(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed'; // 防止滚动到页面底部
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    document.execCommand('copy');
    window.showToast({ message: '已复制到粘贴板' });
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textarea);
}

const deleteImage = (index) => {
  imageList.value.splice(index, 1);
  fileList.value.splice(index, 1);
};

const triggerFileInput = () => {
  if (imageList.value.length >= 8) {
    window.showToast({ message: '最多上传8张图片', timeout: 3000 });
  } else {
    fileInput.value.click();
  }
};

const handleFileChange = (event) => {
  const maxSize = 10 * 1024 * 1024;
  const files = Array.from(event.target.files);
  const newImages = files.filter(file => file.size <= maxSize).map(file => URL.createObjectURL(file));
  const newFiles = files.filter(file => file.size <= maxSize);
  if (newImages.length < files.length) {
    window.showToast({ message: '单张图片大小超过限制（10MB），请重新上传' });
  }

  const totalImages = imageList.value.length + newImages.length;

  if (totalImages > 8) {
    const allowedNewImages = 8 - imageList.value.length;
    const truncatedImages = newImages.slice(0, allowedNewImages);
    const truncatedFiles = newFiles.slice(0, allowedNewImages);
    imageList.value = [...imageList.value, ...truncatedImages];
    fileList.value = [...fileList.value, ...truncatedFiles];
    window.showToast({ message: '最多上传8张图片', timeout: 3000 });
  } else {
    imageList.value = [...imageList.value, ...newImages];
    fileList.value = [...fileList.value, ...newFiles];
  }

  event.target.value = ''; // Reset file input
};

const submitForm = async () => {
  if (content.value.trim().length < 8) {
    window.showToast({ message: '请详细描述问题，不低于8个字' });
    return;
  }
  if (content.value.trim().length > 140) {
    window.showToast({ message: '请简要描述问题，不超过140个字' });
    return;
  }
  if (qq.value.trim() && !/^[-_@0-9a-zA-Z]+$/.test(qq.value.trim())) {
    window.showToast({ message: '请输入字母数字下划线等合法字符' });
    return;
  }
  if (qq.value.trim() && qq.value.trim().length < 4) {
    window.showToast({ message: '联系方式不少于4个字' });
    return;
  }
  if (qq.value.trim() && qq.value.trim().length > 30) {
    window.showToast({ message: '请提供简要的联系方式，不超过30个字' });
    return;
  }

  isShowLoading.value = true;
  const formData = new FormData();
  fileList.value.forEach((file, index) => {
    formData.append(`images[${index}]`, file);
  });
  formData.append('content', content.value);
  if (qq.value.trim().length > 0) {
    formData.append('qq', qq.value.trim());
    setQq(qq.value.trim());
  }
  formData.append('productId', computed(() => store.getters.getProductId).value);
  formData.append('BuildBrand', computed(() => store.getters.getBuildBrand).value);
  formData.append('BuildModel', computed(() => store.getters.getBuildModel).value);
  formData.append('systemVersion', computed(() => store.getters.getSystemVersion).value);
  formData.append('softVesion', computed(() => store.getters.getSoftVersion).value);
  formData.append('imei', computed(() => store.getters.getImei).value);
  formData.append('guid', computed(() => store.getters.getGuid).value);
  formData.append('channel', computed(() => store.getters.getChannel).value);
  formData.append('BuildID', computed(() => store.getters.getBuildID).value);
  axios.post('/feedback', formData).then(res => {
    isShowLoading.value = false;
    if (res.data.result !== 0) {
      window.showToast({ message: res.data.msg });
      return;
    }
    isShowSuccess.value = true;
  }).catch(err => {
    console.log(err);
    isShowLoading.value = false;
    window.showToast({ message: '提交反馈失败，请稍后再试' });
  });
};
</script>

<template>
  <div class="form">
    <p class="label-required">问题描述或建议</p>
    <div class="textarea-container">
      <textarea class="textarea" v-model="content" placeholder="请详细描述问题，不低于8个字" maxlength="140"></textarea>
      <div class="char-count">{{ inputLen }} / 140</div>
    </div>
    <p class="label">图片<span class="label-comment">（选填）</span></p>
    <p class="label-comment-small">请您上传问题截图；最多上传8张图片，单张大小不超过10MB</p>
    <div class="image-uploader">
      <div class="image-list-wrapper" ref="imageListWrapper">
        <div class="image-item" v-for="(image, index) in imageList" :key="index">
          <img :src="image" class="image-thumbnail" alt=""/>
          <button class="delete-button" @click="deleteImage(index)"></button>
        </div>
        <div class="image-item add-button" @click="triggerFileInput">
          <input type="file" accept=".jpg, .jpeg, .png" ref="fileInput" @change="handleFileChange" multiple style="display: none;" />
        </div>
      </div>
    </div>
    <p class="label">联系方式<span class="label-comment">（选填）</span></p>
    <input type="text" v-model="qq" class="input" placeholder="QQ号码，便于与您沟通解决问题"/>
    <p class="label" v-if="showContact">联系我们<span class="label-comment-small">&nbsp;&nbsp;官方QQ群：142455026<button class="button" @click="copyToClipboard(142455026)">复制</button> </span></p>
  </div>
  <div class="entrance-box">
    <button :class="submitButtonClass" @click="submitForm">提交</button>
  </div>
  <div v-if="isShowSuccess">
    <div class="overlay"></div>
    <div class="window-box">
      <img src="../assets/ok.png" class="image" alt="image"/>
      <p class="label">成功提交</p>
      <p class="label2">我们已经收到您的反馈</p>
      <div class="buttons">
        <button class="button1" @click="goToHome">关闭</button>
        <button class="button2" @click="goToMyList">查看反馈进度</button>
      </div>
    </div>
  </div>
  <div v-if="isShowLoading">
    <div class="overlay"></div>
    <div class="loading-box">
      <img src="../assets/loading.png" class="loading-icon" alt=""/>
      <p class="loading-text">正在提交...</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~/entries/index/index.scss';
@mixin label {
  font-size: 28 * $px;
  line-height: 42 * $px;
}
.form {
  margin: 36 * $px 48 * $px;
  padding-bottom: 150*$px;

  .label-required {
    @include label;
    &::after {
      content: '*';
      color: red;
    }
  }
  .label {
    @include label;
  }
  .label-comment {
    @include label;
    color: rgba(188, 188, 188, 1);
  }
  .label-comment-small {
    font-size: 24 * $px;
    line-height: 33.6 * $px;
    color: rgba(188, 188, 188, 1);
  }
  .textarea-container {
    position: relative;
    width: 614 * $px;
  }
  .textarea {
    width: 100%;
    height: 221 * $px;
    border: 0;
    outline: none;
    box-shadow: none;
    border-radius: 14 * $px;
    padding: 16 * $px 20 * $px;
    font-size: 24 * $px;
    line-height: 33.6 * $px;
    background: rgba(247, 247, 247, 1);
  }
  .textarea::placeholder {
    color: #bcbcbc;
  }
  .char-count {
    position: absolute;
    bottom: 28 * $px;
    right: 0 * $px;
    text-align: right;
    font-size: 20*$px;
    line-height: 28*$px;
    color: rgba(188, 188, 188, 1);
  }
  .photo {
    width: 147 * $px;
    height: 147 * $px;
  }
  .input {
    width: 614 * $px;
    height: 82 * $px;
    border: 0;
    border-radius: 14 * $px;
    outline: none;
    box-shadow: none;
    padding: 0 20 * $px;
    font-size: 24 * $px;
    line-height: 33.6 * $px;
    background: rgba(247, 247, 247, 1);
  }
  .input::placeholder {
    color: #bcbcbc;
  }
  .button {
    width: 100 * $px;
    height: 42 * $px;
    background: rgba(231, 235, 255, 1);
    color: rgba(75, 106, 255, 1);
    border-radius: 36 * $px;
    border: none;
    margin-left: 20 * $px;
    box-shadow: none;
    outline: none;
  }
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
}
.window-box {
  z-index: 9999;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 585*$px;
  height: 514*$px;
  border-radius: 14*$px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(109, 136, 255, 1) -70%, rgba(255, 255, 255, 1) 30.58%);
  .image {
    width: 100*$px;
    height: 100*$px;
    margin-top: 59*$px;
  }
  .label {
    font-size: 36*$px;
    font-weight: bold;
    line-height: 50*$px;
    margin-block-start: 32*$px;
    margin-block-end: 5*$px;
  }
  .label2 {
    margin-block-start: 5*$px;
    font-size: 28*$px;
    line-height: 42*$px;
    margin-block-end: 80*$px;
  }

  .buttons {
    display: flex;
    justify-content: center;
    height: 153*$px;
    @mixin button{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10*$px 20*$px;
      margin: 0 10 * $px;
      border-radius: 45 * $px;
      font-size: 28 * $px;
      width: 252.5 * $px;
      height: 79 * $px;
      box-shadow: none;
      outline: none;
    }
    .button1 {
      @include button;
      background: #fff;
      color: #000;
      border: 2*$px solid rgba(221, 221, 221, 1);
    }
    .button2 {
      @include button;
      background: rgba(75, 106, 255, 1);
      color: #fff;
      border: 0;
    }
  }
}
.entrance-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  background: #fff;
  width: 100%;
  height: 141 * $px;
  position: fixed; /* 设置entrance-box为绝对定位 */
  bottom: 0; /* 将entrance-box固定在底部 */

  @mixin button{
    color: white;
    font-size: 32 * $px;
    line-height: 44.8 * $px;
    border: none;
    border-radius: 60 * $px;
    width: 625 * $px;
    height: 93 * $px;
    box-shadow: none;
    outline: none;
  }
  .feedback {
    @include button;
    background: rgba(75, 106, 255, 1);
  }
  .feedback-not-ok {
    @include button;
    background: rgba(210, 216, 243, 1);
  }
}

.image-uploader {
  display: flex;
  overflow-x: auto;
}

.image-list-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow: visible;
}

.image-item {
  position: relative;
  width: 147 * $px;
  height: 147 * $px;
  margin-right: 16*$px;
  margin-top: 6*$px;
  border-radius: 14*$px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(247, 247, 247, 1);
  overflow: visible;
}

.image-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 14*$px;
}

.delete-button {
  position: absolute;
  top: -6*$px;
  right: -6*$px;
  border: none;
  border-radius: 50%;
  width: 40*$px;
  height: 40*$px;
  display: flex;
  background-image: url("../assets/x.png");
  background-size: cover;
}

.add-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/upload.png");
  background-position: center;
  background-size: contain;
  border: none;
}
.loading-box {
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  width: 245*$px;
  height: 104*$px;
  border-radius: 14*$px;
}
.loading-icon {
  width: 40*$px;
  height: 40*$px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loading-text {
  margin-left: 10*$px;
  font-size: 28*$px;
  line-height: 36.4*$px;
}
</style>
